import { Block, Button, H3, P } from '@mote/ui'
import styled, { th } from '@xstyled/styled-components'

export const Notice = ({ Icon, title, description, cta = {} }) => {
  const ctaProps = { text: 'Try again', ...cta }
  return (
    <Container role='alert' align='center' justify='center' gap={16} spreadY>
      <Icon aria-hidden={true} tabIndex={-1} role='presentation' />
      <Title fontSize={20} fontWeight={500} lineHeight='140%'>
        {title}
      </Title>
      <Description
        fontSize={15}
        fontWeight={400}
        lineHeight='120%'
        color='grey.d2'
        alignment='center'
      >
        {description}
      </Description>
      {cta.action && (
        <Action
          variant='ghost'
          text={ctaProps.text}
          onClick={ctaProps.action}
        />
      )}
    </Container>
  )
}

const Container = styled(Block)``
const Title = styled(H3)``

const Description = styled(P)`
  margin: 0 16px;
`

const Action = styled(Button)`
  span {
    color: ${th.color('primary.base')};
  }

  &:hover {
    span {
      color: ${th.color('primary.d1')};
    }
  }

  &:active {
    span {
      color: ${th.color('primary.d2')};
    }
  }
`
